export default "__VITE_ASSET__7825671f__"